import { ClickAwayListener, Stack, Tooltip } from '@mui/material';

interface Props {
	open: boolean;
	dropElement: React.ReactElement;
	iconElement: React.ReactElement;
	onClose: () => void;
	closeOnBackdropClick?: boolean;
}

export const HeaderIconTooltip: React.FC<Props> = ({
	open,
	dropElement,
	iconElement,
	onClose,
	closeOnBackdropClick = false,
}) => (
	<ClickAwayListener onClickAway={onClose}>
		<Stack
			sx={{
				cursor: 'pointer',
			}}
		>
			<Tooltip
				placement="bottom"
				open={open}
				onClose={onClose}
				disableFocusListener
				disableHoverListener
				disableTouchListener
				TransitionProps={{ timeout: 0 }}
				PopperProps={{
					onClick: closeOnBackdropClick ? onClose : undefined,
					sx: {
						position: 'fixed !important',
						width: '100vw',
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						opacity: '1',
						height: 'calc(100vh - var(--mini-cart-top, 66px))',
						top: 'var(--mini-cart-top, 66px) !important',
						left: '0 !important',
						transform: 'none !important',
					},
				}}
				componentsProps={{
					transition: {
						sx: {
							backgroundColor: 'transparent',
							color: '#2C2C2C',
							float: 'right',
						},
					} as any,
				}}
				title={<Stack onClick={(event) => event.stopPropagation()}>{dropElement}</Stack>}
			>
				{iconElement}
			</Tooltip>
		</Stack>
	</ClickAwayListener>
);
